import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=63e58d84&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=63e58d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e58d84",
  null
  
)

export default component.exports